// extracted by mini-css-extract-plugin
export default {"icon":"FormInput_icon__Bh7q6"};